// Single source of truth for brand colors used across the onboarding /
// dashboard / knowledge surfaces. Previously duplicated across ~9 files.
//
// If a tone is missing, add it here once — never re-declare a local BRAND.

export const BRAND = {
  // Primary brand
  blue:       '#4080F2',
  blueDeep:   '#2554B0',
  blueSoft:   '#EEF3FF',

  // Accent
  yellow:     '#FFEA00',
  yellowSoft: '#FFFBE0',

  // Neutrals
  black:      '#111827',
  surface:    '#FAFAFA',

  // Status
  green:      '#16A34A',
  greenSoft:  '#E8F8EE',
  amber:      '#F59E0B',
  red:        '#DC2626',

  // Text scale (matches the dashboard typography ramp)
  textPrimary: '#111827',
  textMuted:   '#6B7280',
  textFaint:   '#9CA3AF',
} as const;

export type BrandToken = keyof typeof BRAND;
